/* eslint-disable i18next/no-literal-string */
import React, {Component} from 'react';

import {getGlobalThemeValue} from 'utils/ui';

import Card from 'components/Card';
import CenterContent from 'components/CenterContent';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import Heading from 'components/Heading';
import Icon from 'components/Icon';
import Landmark from 'components/Landmark';
import Panel from 'components/Panel';
import Text from 'components/Text';
import TextLink from 'components/TextLink';

import Checks from './checks';

import store from 'utils/store';

export default class Compatibility extends Component {
	constructor(props) {
		super(props);
		this.state = {
			tests: [],
			showBrowserStatement: false,
		};

		this.continueHandler = this.continueHandler.bind(this);

		Checks().then(tests => {
			this.setState({tests});
		});

		this.toggleBrowserStatement = this.toggleBrowserStatement.bind(this);
	}

	toggleBrowserStatement() {
		this.setState({
			showBrowserStatement: !this.state.showBrowserStatement,
		});
	}

	continueHandler() {
		// Record that the feature tests even
		store('featureTestsIgnore', true);

		if (this.props.onContinue) {
			this.props.onContinue();
		}
	}

	render() {
		let passed = true;
		const rows = this.state.tests.map(item => {
			if (item[1]) {
				passed = false;
			}
			let result = item[1];
			if (result) {
				result = (
					<span>
						<Icon name="x" /> {result}
					</span>
				);
			} else {
				result = (
					<span>
						<Icon name="ok" /> Passed
					</span>
				);
			}
			return (
				<tr key={item[0]}>
					<td>{item[0]}:</td>
					<td style={{textAlign: 'right'}}>{result}</td>
				</tr>
			);
		});

		const details = (
			<table>
				<tbody>{rows}</tbody>
			</table>
		);

		const testResult = passed ? (
			<Panel>
				<Landmark icon="ok">
					Great, your browser passed{' '}
					<Dropdown content={details} variant="raised" p="xs">
						{dropdown => (
							<TextLink
								ref={dropdown.ref}
								as="button"
								onClick={dropdown.toggle}
							>
								our checks
								<Icon vAlign name="chevron" />
							</TextLink>
						)}
					</Dropdown>
				</Landmark>
			</Panel>
		) : (
			<Panel>
				<Landmark icon="flag">
					Your browser failed{' '}
					<Dropdown content={details} variant="raised" p="xs">
						{dropdown => (
							<TextLink
								ref={dropdown.ref}
								as="button"
								onClick={dropdown.toggle}
							>
								some of our checks
								<Icon vAlign name="chevron" />
							</TextLink>
						)}
					</Dropdown>
				</Landmark>
				<Text as="p" size="s">
					Please use a modern browser like{' '}
					<TextLink
						href="https://www.mozilla.org/en-GB/firefox/new/"
						target="_blank"
						rel="noopener noreferrer"
					>
						Firefox
					</TextLink>
					,{' '}
					<TextLink
						href="https://www.google.com/chrome/browser/desktop/"
						target="_blank"
						rel="noopener noreferrer"
					>
						Chrome
					</TextLink>
					,{' '}
					<TextLink
						href="https://www.microsoft.com/en-gb/windows/microsoft-edge"
						target="_blank"
						rel="noopener noreferrer"
					>
						Edge
					</TextLink>{' '}
					or{' '}
					<TextLink
						href="https://www.opera.com/download"
						target="_blank"
						rel="noopener noreferrer"
					>
						Opera
					</TextLink>{' '}
					when visiting the Digital Hub.
				</Text>
			</Panel>
		);

		return (
			<CenterContent
				fillParent
				contentWidth={getGlobalThemeValue('modalWidths', 'default')}
			>
				<Card variant="raised">
					<Panel align="center">
						<Heading as="h1">
							Digital Hub Compatibility Check
						</Heading>
					</Panel>
					{testResult}
					<Panel align="center">
						<Button onClick={this.continueHandler}>Continue</Button>
					</Panel>
					<Panel align="center">
						<Button
							size="small"
							variant="shaded"
							onClick={this.toggleBrowserStatement}
						>
							Read browser support statement
						</Button>
					</Panel>
					{this.state.showBrowserStatement && (
						<Panel className="u-fade-in">
							<Text as="div" size="s">
								<p>
									We aim to support popular browsers which
									update themselves (sometimes referred to as
									“evergreen browsers”) such as Chrome,
									Firefox, MS Edge, Android Chrome and the
									latest Safari for OSX and iOS.
								</p>
								<p>
									<i>- the dev team</i>
								</p>
							</Text>
						</Panel>
					)}
				</Card>
			</CenterContent>
		);
	}
}
